import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import Navbar from './MainHeader';
import SidebarOryza from './SidebarOryza';
import Sidebar from './SideNavigation';
import '../styles/OffersPage.css';

const OFFER_API = 'https://3rey9w5wwi.execute-api.us-east-1.amazonaws.com/oryzadev/offer/';
const HOTEL_NAME = 'banana-bunks-kandy';

const extractOffers = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.value)) return payload.value;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.items)) return payload.items;
    return [];
};

const formatOfferDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};

const OffersPage = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const checkScreen = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreen();
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    useEffect(() => {
        const preloader = document.getElementById('preloader');
        if (preloader) {
            setTimeout(() => {
                preloader.style.display = 'none';
            }, 500);
        }
    }, []);

    useEffect(() => {
        const controller = new AbortController();

        const loadOffers = async () => {
            setLoading(true);
            setError('');

            try {
                const response = await fetch(OFFER_API, { signal: controller.signal });
                if (!response.ok) {
                    throw new Error('Unable to load offers');
                }

                const payload = await response.json();
                const activeHotelOffers = extractOffers(payload).filter(
                    (offer) =>
                        offer.hotelName === HOTEL_NAME &&
                        String(offer.status || '').toLowerCase() === 'active'
                );

                setOffers(activeHotelOffers);
            } catch (err) {
                if (err.name === 'AbortError') return;
                setError('Unable to load offers right now. Please try again later.');
                setOffers([]);
            } finally {
                setLoading(false);
            }
        };

        loadOffers();
        return () => controller.abort();
    }, []);

    const headingStyle = {
        fontFamily: "'Yellowtail', cursive",
        fontWeight: 400,
        fontSize: isMobile ? '40px' : '79px',
        lineHeight: isMobile ? '48px' : '95px',
        color: '#fff',
    };

    const HeroSection = {
        backgroundImage: 'url(../bbkandy/images/rooms/header.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        height: isMobile ? '238px' : '480px',
    };

    return (
        <div className="offers-page">
            <div id="preloader">
                <div data-loader="circle-side"></div>
            </div>

            <style>
                {`
          @import url('https://fonts.googleapis.com/css?family=Jost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CAmiri%3Aregular%2Citalic%2C700%2C700italic%7CAllison%3Aregular&#038;subset=cyrillic%2Clatin%2Clatin-ext%2Carabic%2Cvietnamese&#038;ver=6.0.1');
          @import url('https://fonts.googleapis.com/css?family=Oswald%3A200%2C300%2Cregular%2C500%2C600%2C700%7CMerriweather%3A300%2C300italic%2Cregular%2Citalic%2C700%2C700italic%2C900%2C900italic%7CJost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CMontserrat%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2Cregular%2Citalic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CAllison%3Aregular&#038;subset=cyrillic%2Ccyrillic-ext%2Clatin%2Clatin-ext%2Cvietnamese&#038;ver=6.0.1');
          @import url('https://fonts.googleapis.com/css2?family=Boogaloo&family=Lato:wght@100;300;400;900&display=swap');
          @import url('https://fonts.googleapis.com/css2?family=Handlee&family=Neucha&family=Pacifico&family=Patrick+Hand&family=Patrick+Hand+SC&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sacramento&display=swap');
          @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');
        `}
            </style>

            <Header />
            <Navbar />
            <SidebarOryza />
            <Sidebar />

            <div
                className="hotale-page-title-wrap hotale-style-custom hotale-center-align"
                style={HeroSection}
            >
                <div className="hotale-header-transparent-substitute" style={{ height: '135px' }}></div>
                <div
                    className="hotale-page-title-overlay"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.3)'
                    }}
                ></div>
                <div
                    className="hotale-page-title-container hotale-container"
                    style={{
                        maxWidth: '1140px',
                        margin: '0 auto',
                        padding: '80px 15px',
                        position: 'relative',
                        zIndex: 1
                    }}
                >
                    <div
                        className="hotale-page-title-content hotale-item-pdlr"
                        style={{ padding: '0 15px' }}
                    >
                        <h1 className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font slidertitle"
                        style={headingStyle}>
                            Offers
                        </h1>
                    </div>
                </div>
            </div>

            <div
                className="hotale-page-wrapper bbkandybg offers-page-content"
                id="hotale-page-wrapper"
            >
                <div className="gdlr-core-page-builder-body">
                    <div className="gdlr-core-pbf-section">
                        <div className="gdlr-core-pbf-section-container gdlr-core-container clearfix offers-section-container">
                            <div className="offers-grid">
                                {loading && (
                                    <h3 className="offers-status-message">Loading offers...</h3>
                                )}

                                {!loading && error && (
                                    <h3 className="offers-status-message">{error}</h3>
                                )}

                                {!loading && !error && offers.length === 0 && (
                                    <h3 className="offers-status-message">
                                        There are no offers at the moment!
                                    </h3>
                                )}

                                {!loading && !error && offers.map((item) => (
                                    <article className="offer-card" key={item._id || item.title}>
                                        <div className="offer-card-image-wrap">
                                            <img
                                                className="offer-card-image"
                                                src={item.image}
                                                alt={item.title || 'Offer'}
                                            />
                                        </div>
                                        <div className="offer-card-body">
                                            {item.date && (
                                                <div className="offer-card-date">
                                                    <i className="fas fa-clock"></i>
                                                    {formatOfferDate(item.date)}
                                                </div>
                                            )}
                                            <h3 className="offer-card-title">{item.title}</h3>
                                            {item.description && (
                                                <div
                                                    className="offer-card-description"
                                                    dangerouslySetInnerHTML={{ __html: item.description }}
                                                ></div>
                                            )}
                                        </div>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default OffersPage;
